import { Outlet } from "react-router-dom";
import AuthCheckProvider from "@/providers/auth-check-provider";

const AuthLayout = () => {
  return (
    <AuthCheckProvider
      checking={({ token, isTokenExpired, navigate }) => {
        if (token && !isTokenExpired) {
          navigate("/");
        }
      }}
    >
      <Outlet />
    </AuthCheckProvider>
  );
};

export default AuthLayout;
